<template>
  <v-chip label :class="{ 'w-100': full_with }" :size="size" :color="computedStatusColor">
    <v-icon :size="16" :color="computedStatusColor">fal fa-circle</v-icon>
    <span v-if="type === 'chip'" class="ml-2">{{ selectedStatus ? selectedStatus.name : "-" }}</span>
  </v-chip>
</template>

<script>
export default {
  name: "StatusChip",
  props: {
    statuses: { type: Array, required: true },
    type: { type: String, default: "" },
    selected: { type: Number, required: true },
    full_with: { type: Boolean, default: false },
    size: { type: String, default: "default" },
  },
  computed: {
    // Get the selected status object from statuses array
    selectedStatus() {
      return this.statuses.find(status => status.id === this.selected) || null;
    },
    // Get color from selected status
    computedStatusColor() {
      return this.selectedStatus ? this.selectedStatus.color : "#ccc";
    },
  },
};
</script>

<style scoped>
.status-circle {
  width: 18px !important;
  height: 18px !important;
  min-width: 18px !important;
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.status-circle div {
  width: 14px;
  height: 14px;
  border: 2px solid #fff;
  border-radius: 100px;
}

.status-chip {
  border-radius: 8px;
  text-align: center;
  width: auto;
  padding: 8px 4px;
  margin: auto;
  display: inline-block;
}

.status-chip-inner {
  border-radius: 8px;
}

.chip-w-100 {
  .status-chip {
    display: block;
  }
}
</style>
